export default "__VITE_ASSET__Cea5QYI9__"